import { useOptionalCommitmentEventSelectionContext } from '../components/commitmentEvents/commitmentEventSelectionContext'
import { eventSelectionToPreviousEventSelection } from '../components/commitmentEvents/commitmentEventSelectionProviderLogic'
import { useHook } from '../lenteHooks'
import { useFilterCommands } from './useFilterCommands'

export const useCommitmentVersionSelection = () => {
  const eventSelectionContext = useOptionalCommitmentEventSelectionContext()
  const { ownerId, tenantId } = useHook('routing.general.useEntityParams')()

  const { data: commitmentCommands } = useHook(
    'fetchers.life.useFetchCommitmentCommandsNoSuspense',
  )(
    {
      tenantId,
      ownerId,
    },
    {
      enabled: !!eventSelectionContext?.previous,
      throwOnError: false,
    },
  )

  const commandAndEventData = useFilterCommands(commitmentCommands)
  const previousSelection = eventSelectionContext?.previous
    ? eventSelectionToPreviousEventSelection(
        eventSelectionContext.previous,
        commandAndEventData,
      )
    : undefined

  const currentSelectionSimulationDate =
    eventSelectionContext?.current?.type === 'unappliedCommand'
      ? eventSelectionContext.current.applyDate
      : undefined
  const previousSelectionSimulationDate =
    previousSelection?.type === 'unappliedCommand'
      ? eventSelectionContext?.previous?.applyDate
      : undefined

  return {
    currentSelection: eventSelectionContext?.current,
    previousSelection,
    currentSelectionSimulationDate,
    previousSelectionSimulationDate,
  }
}
